import {useSelector} from 'react-redux';

/**
 * Whether the current user has the manager role.
 * @returns {boolean}
 */
export const useIsManager = () => useSelector(state => state.user.isManager);
